import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { CheckCircle, Download, Mail, Home } from 'lucide-react';
import './CheckoutSuccessPage.css';

const CheckoutSuccessPage = () => {
  const navigate = useNavigate();
  const { clearCart } = useCart();

  useEffect(() => {
    // Clear cart on successful checkout
    clearCart();
  }, [clearCart]);

  return (
    <div className="success-page">
      <div className="container">
        <div className="success-content">
          <div className="success-icon">
            <CheckCircle size={64} />
          </div>
          
          <h1 className="success-title">
            Order <span className="gradient-text">Confirmed!</span>
          </h1>
          
          <p className="success-message">
            Thank you for your purchase! Your digital posters have been sent to your email.
          </p>

          <div className="info-cards">
            <div className="info-card">
              <Mail size={32} />
              <h3>Check Your Email</h3>
              <p>
                Your high-resolution digital posters have been sent to the email address 
                associated with your account.
              </p>
            </div>

            <div className="info-card">
              <Download size={32} />
              <h3>Download & Print</h3>
              <p>
                Download your files and take them to your local print shop for 
                professional quality printing.
              </p>
            </div>
          </div>

          <div className="success-actions">
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/profile')}
            >
              View Order History
            </button>
            <button 
              className="btn btn-secondary"
              onClick={() => navigate('/shop')}
            >
              <Home size={20} />
              Continue Shopping
            </button>
          </div>

          <div className="support-info">
            <p>
              Need help? Contact us at{' '}
              <a href="mailto:hello@trcklst.com">hello@trcklst.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccessPage;